<template>
    <van-popup v-model:show="show" round :overlay-style="{ overflow: 'hidden' }" :style="{
        width: '80%',
        Height: '50%',
        background: '#27190D',
        borderRadius: '30px'
    }">
        <van-row class="popup_head">
            <van-col span="20" offset="2" class="alignements">
                Em breve poderá sacar
            </van-col>
            <van-col span="2" class="alignements">
                <div class="close_icon alignements" @click="close">
                    <van-icon name="cross" />
                </div>
            </van-col>
        </van-row>
        <div class="pop_content">
            <div class="total_text">Total de dinheiro a ser pago em breve</div>
            <div class="money_amount">
                <img src="@/assets/cashwheel/pddv2_top_money.png" alt="">
                <div class="amount_text">{{ formatCurrency(animatedValue) }}</div>
                <div class="currency_text">BTC</div>
            </div>

            <div class="text1">Formas de Pagamentos</div>
            <div class="paymeny_method">
                <van-steps direction="vertical" :active="1" finish-icon="success" active-iconfinish-icon="success">
                    <van-step>
                        <div>O pedido de pagamento foi submetido</div>
                    </van-step>
                    <van-step>
                        <div>Ainda é necessário 4.28 para realizar o saque</div>
                    </van-step>
                    <van-step>
                        <div>100 R$ serão pagos na sua conta Pix</div>
                    </van-step>
                </van-steps>

            </div>
            <div class="btn_container">
                <img src="@/assets/cashwheel/pddv2_pop_btn_com.png" alt="" @click="showSharePopup">
            </div>
        </div>
    </van-popup>
    <ShareContent ref="sharePopupRef" />
</template>

<script setup lang="ts">
import { ref, defineExpose, watch } from 'vue'
import ShareContent from './shareContent.vue'
import { formatCurrency } from '@/utils/commonFunction'
const show = ref(false)
const sharePopupRef = ref()
const animatedValue = ref(0)
const resData = ref()
const open = (data: any) => {
    show.value = true
    resData.value = data

    const target = resData.value.user_pdd_info.current_progress / 100
    animateValue(0, target, 800)
}
const close = () => {
    show.value = false
}
const showSharePopup = () => {
    sharePopupRef.value.open()
}
const animateValue = (start: number, end: number, duration: number) => {
    const startTime = performance.now()

    const step = (currentTime: number) => {
        const progress = Math.min((currentTime - startTime) / duration, 1)
        animatedValue.value = start + (end - start) * progress

        if (progress < 1) {
            requestAnimationFrame(step)
        } else {
            animatedValue.value = end
        }
    }

    requestAnimationFrame(step)
}

defineExpose({
    open,
    close
})
</script>
<style scoped>
.popup_head {
    color: #fff;
    padding: 15px;
}

.alignements {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 15px;
}

.van-overlay {
    background-color: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(8px);
}

.close_icon {
    background: rgba(0, 0, 0, 0.25);
    padding: 5px;
    border-radius: 30px;
}

.pop_content {
    border-radius: 30px;
    background: #3D2E22;
    width: 100%;
}

.money_amount {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: center;
}

.money_amount img {
    width: 25px;
}

.amount_text {
    font-size: 38px;
    font-weight: bold;
    color: #F0A853;
    padding: 0 10px;
}

.total_text {
    padding: 25px;
    color: rgba(255, 255, 255, 0.65);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.currency_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    font-weight: bold;
}

.text1 {
    color: #fff;
    padding: 10px 25px;
    font-size: 11px;
}

.paymeny_method {
    font-family: Arial;
    font-size: 10px;
    padding: 10px 0;
    background: #27190D;
    border-radius: 20px;
    margin: 0px 20px;
    border: 2px solid rgba(0, 0, 0, 0.25);
}

.van-steps {
    background: transparent;
}

.van-step--vertical {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.85) !important;
    padding: 5px;
}

.paymeny_method>>>.van-step__title--active {
    color: rgba(255, 255, 255, 0.85) !important;
}

.paymeny_method>>>.van-step__icon--active {
    color: #6ddf39 !important;
    background-color: #fff !important;
    border-radius: 30px;
}

.paymeny_method>>>.van-step__line {
    background-color: #3cc517 !important;
    width: 0.5px;
}

.paymeny_method>>>.van-step__icon--finish {
    color: #ffffff;
    background: #6ddf39;
    border-radius: 30px;
    font-size: 6px;
    padding: 3px
}

[class*=van-hairline]:after {
    border: none !important;
}

.btn_container {
    padding: 20px 50px;
}

.btn_container img {
    width: 100%;
}
</style>